import { BASE_URL, INDIAN_MSME_USER_TOKEN } from "../../utils/Constants";
import { RootState } from "..";
import axios from "axios";
import { ThunkAction } from "redux-thunk";
import POSType, {
  GetSellerWiseProductList,
  AddToCart,
  GetCartList,
  UpdateCart,
  RemoveCartItem,
  CreateOrder,
  RemoveAllItem,
  GetProductVariantDetails,
  GetProductDetails,
} from "../types/POSType";
import { getCookie } from "../../utils/CookieAction";
import LogoutAction from "./LogoutAction";
import { toast } from "react-toastify";
import { get } from "http";
interface Action {
  type: string;
  payload?: any;
  message?: string;
}

const POSAction = {
  getSellerWiseProductList:
    (
      data: GetSellerWiseProductList
    ): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const response: any = await axios.post(
          BASE_URL + "pos/product-list",
          {
            search: data.search,
            limit: data.limit,
            page: data.page,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );
        dispatch({
          type: POSType.SET_SELLER_WISE_PRODUCT_LIST,
          payload: {
            data: response.data.data.products,
            page: data.page,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  addCart:
    (data: AddToCart): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      console.log(data.isVariant);
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "pos/add-to-cart",
          {
            product_id: data.product_id,
            user_id: data.user_id,
            size: data.size,
            color: data.color,
            isVariant: data.isVariant,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: POSType.SET_ADD_TO_CART,
            payload: {
              data: data.product_id,
            },
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getCartList:
    (data: GetCartList): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getCartData: any = await axios.post(
          BASE_URL + "pos/cart-list",
          {
            user_id: data.user_id,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: POSType.GET_CART_LIST,
          payload: {
            data: getCartData.data.data.cartData,
            totalQty: getCartData.data.data.totalQty,
            totalTax: getCartData.data.data.totalTax,
            totalAmount: getCartData.data.data.totalAmount,
            totalPV: getCartData.data.data.totalPV,
            deliveryCharge: getCartData.data.data.deliveryCharge,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  updateCart:
    (data: UpdateCart): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "pos/update-cart",
          { product_id: data.id, action: data.action, qty: data.qty },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: POSType.UPDATE_CART,
            payload: {
              id: data.id,
              type: data.action,
            },
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  removeCartItem:
    (data: RemoveCartItem): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "pos/remove-cart",
          { id: data.id },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: POSType.REMOVE_CART_ITEM,
            payload: {
              id: data.id,
            },
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  createOrder:
    (data: CreateOrder): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const result: any = await axios.post(
          BASE_URL + "pos/order-generate",
          {
            user_id: data.user_id,
            deliveryCharge: data.deliveryCharge,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: POSType.ORDER_GENERATES,
          });
          toast.success("Order Generated successfully");
          setTimeout(function () {
            window.location.reload();
          }, 1500);
        } else {
          toast.error(result.data.msg);
          return false;
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        } else if (error.response.status === 500) {
          toast.error(error.response.statusText);
        }
      }
    },

  removeAllItem:
    (data: RemoveAllItem): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "pos/remove-all-items",
          { user_id: data.user_id },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );
        if (result.data.status) {
          dispatch({
            type: POSType.REMOVE_ALL_ITEM,
          });
          toast.error("Removed All Cart Items");
          setTimeout(function () {
            window.location.reload();
          }, 150);
        } else {
          toast.error(result.data.msg);
          return false;
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getProductVariantDetails:
    (
      data: GetProductVariantDetails
    ): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.get(
          `${BASE_URL}pos/products-details-variant/${data.product_id}/${data.size}/${data.color}`,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: POSType.GET_PRODUCT_DETAILS,
            payload: {
              data: result.data.data,
            },
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getProductDetails:
    (data: GetProductDetails): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.get(
          `${BASE_URL}pos/products-details/${data.slug}?product_id=${data.product_id}`,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: POSType.GET_PRODUCT_DETAILS,
            payload: {
              data: result.data.data,
            },
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
};

export default POSAction;
